"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_ABI } from "@/abis";
import { useAuth } from "@/components/auth/Auth";
import { PRIMARY_ADDRESS_USE_CASE } from "@/components/delegation/delegation-constants";
import EtherscanIcon from "@/components/user/utils/icons/EtherscanIcon";
import OpenseaIcon from "@/components/user/utils/icons/OpenseaIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT, NEVER_DATE } from "@/constants";
import { ApiWallet } from "@/generated/models/ApiWallet";
import { getTransactionLink } from "@/helpers/Helpers";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import UserPageIdentityStatementsConsolidatedAddressesItemPrimary from "./UserPageIdentityStatementsConsolidatedAddressesItemPrimary";
export default function UserPageIdentityStatementsConsolidatedAddressesItem(t0) {
  const $ = _c(90);
  const {
    address,
    primaryAddress,
    canEdit
  } = t0;
  const {
    setToast
  } = useAuth();
  let t1;
  if ($[0] !== address.wallet) {
    t1 = e => {
      e.stopPropagation();
      window.open(`https://opensea.io/${address.wallet}`, "_blank");
    };
    $[0] = address.wallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const goToOpensea = t1;
  let t2;
  if ($[2] !== address.wallet) {
    t2 = () => {
      window.open(`https://etherscan.io/address/${address.wallet}`, "_blank");
    };
    $[2] = address.wallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const goToEtherscan = t2;
  let t3;
  if ($[4] !== address.wallet) {
    t3 = address.wallet.toLowerCase();
    $[4] = address.wallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== primaryAddress) {
    t4 = primaryAddress?.toLowerCase();
    $[6] = primaryAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isPrimary = t3 === t4;
  let t5;
  if ($[8] !== address.wallet) {
    t5 = address.wallet.slice(0, 6);
    $[8] = address.wallet;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [title, setTitle] = useState(t5);
  const [, copyToClipboard] = useCopyToClipboard();
  let t6;
  if ($[10] !== address.wallet || $[11] !== copyToClipboard) {
    t6 = () => {
      copyToClipboard(address.wallet);
      setTitle("Copied!");
      setTimeout(() => {
        setTitle(address.wallet.slice(0, 6));
      }, 1000);
    };
    $[10] = address.wallet;
    $[11] = copyToClipboard;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleCopy = t6;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t8 = [];
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  const [assigningPrimary, setAssigningPrimary] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const writeDelegation = useWriteContract();
  let t9;
  if ($[15] !== writeDelegation.data) {
    t9 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[15] = writeDelegation.data;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t9);
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = function getError(e_0) {
      return e_0.message.split("Request Arguments")[0];
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const getError = t10;
  let t11;
  if ($[18] !== setToast || $[19] !== waitWriteDelegation.data || $[20] !== waitWriteDelegation.error || $[21] !== waitWriteDelegation.isLoading || $[22] !== writeDelegation.data || $[23] !== writeDelegation.isPending) {
    t11 = () => {
      if (writeDelegation.isPending) {
        setStatusMessage("Confirm in your wallet...");
      } else {
        if (writeDelegation.data) {
          const trxLink = <>{writeDelegation.data && <a href={getTransactionLink(DELEGATION_CONTRACT.chain_id, writeDelegation.data)} target="_blank" rel="noopener noreferrer" className="tw-text-primary-400 tw-underline">View Transaction</a>}</>;
          if (waitWriteDelegation.isLoading) {
            setStatusMessage(<>Waiting for confirmation... {trxLink}</>);
          } else {
            if (waitWriteDelegation.data) {
              setStatusMessage(<>Confirmed! Check back in a few minutes to see the change. {trxLink}</>);
              setToast({
                type: "success",
                message: "Primary address set successfully"
              });
            } else {
              if (waitWriteDelegation.error) {
                setStatusMessage(<>Error: {getError(waitWriteDelegation.error)} {trxLink}</>);
                setToast({
                  type: "error",
                  message: `Error setting primary address: ${getError(waitWriteDelegation.error)}`
                });
              }
            }
          }
        } else {
          setStatusMessage(undefined);
        }
      }
    };
    $[18] = setToast;
    $[19] = waitWriteDelegation.data;
    $[20] = waitWriteDelegation.error;
    $[21] = waitWriteDelegation.isLoading;
    $[22] = writeDelegation.data;
    $[23] = writeDelegation.isPending;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== waitWriteDelegation.status || $[26] !== writeDelegation.status) {
    t12 = [writeDelegation.status, waitWriteDelegation.status];
    $[25] = waitWriteDelegation.status;
    $[26] = writeDelegation.status;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  useEffect(t11, t12);
  let t13;
  if ($[28] !== address.wallet || $[29] !== writeDelegation) {
    t13 = async () => {
      setAssigningPrimary(true);
      writeDelegation.writeContract({
        address: DELEGATION_CONTRACT.contract,
        abi: DELEGATION_ABI,
        chainId: DELEGATION_CONTRACT.chain_id,
        functionName: "registerDelegationAddress",
        args: [DELEGATION_ALL_ADDRESS, address.wallet, NEVER_DATE, PRIMARY_ADDRESS_USE_CASE.use_case, true, 0]
      });
    };
    $[28] = address.wallet;
    $[29] = writeDelegation;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const assignPrimary = t13;
  const t14 = `opensea-tooltip-${address.wallet}`;
  const t15 = isTouchScreen ? undefined : "Opensea";
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="tw-flex-shrink-0 tw-w-6 tw-h-6 sm:tw-w-5 sm:tw-h-5 hover:tw-scale-110 tw-transition tw-duration-300 tw-ease-out"><OpenseaIcon /></div>;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== goToOpensea || $[33] !== t14 || $[34] !== t15) {
    t17 = <button onClick={goToOpensea} aria-label="Go to Opensea" className="tw-bg-transparent tw-border-none tw-p-0" data-tooltip-id={t14} data-tooltip-content={t15}>{t16}</button>;
    $[32] = goToOpensea;
    $[33] = t14;
    $[34] = t15;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== address.wallet || $[37] !== isTouchScreen) {
    t18 = !isTouchScreen && <Tooltip id={`opensea-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[36] = address.wallet;
    $[37] = isTouchScreen;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = `etherscan-tooltip-${address.wallet}`;
  const t20 = isTouchScreen ? undefined : "Etherscan";
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="tw-flex-shrink-0 tw-w-6 tw-h-6 sm:tw-w-5 sm:tw-h-5 hover:tw-scale-110 tw-transition tw-duration-300 tw-ease-out"><EtherscanIcon /></div>;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== goToEtherscan || $[41] !== t19 || $[42] !== t20) {
    t22 = <button onClick={goToEtherscan} aria-label="Go to Etherscan" className="tw-bg-transparent tw-border-none tw-p-0" data-tooltip-id={t19} data-tooltip-content={t20}>{t21}</button>;
    $[40] = goToEtherscan;
    $[41] = t19;
    $[42] = t20;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== address.wallet || $[45] !== isTouchScreen) {
    t23 = !isTouchScreen && <Tooltip id={`etherscan-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[44] = address.wallet;
    $[45] = isTouchScreen;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== title) {
    t24 = title === "Copied!" ? <span className="tw-text-primary-400">{title}</span> : title;
    $[47] = title;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t24) {
    t25 = <span>{t24}</span>;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== address.display) {
    t26 = address.display && <span className="tw-ml-3">{address.display}</span>;
    $[51] = address.display;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t25 || $[54] !== t26) {
    t27 = <div className="tw-truncate md:tw-max-w-[8rem] lg:tw-max-w-[11rem] tw-text-iron-200">{t25}{t26}</div>;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="#3CCB7F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== address || $[58] !== assignPrimary || $[59] !== assigningPrimary || $[60] !== canEdit || $[61] !== isPrimary) {
    t29 = <UserPageIdentityStatementsConsolidatedAddressesItemPrimary isPrimary={isPrimary} canEdit={canEdit} address={address} assignPrimary={assignPrimary} isAssigningPrimary={assigningPrimary} />;
    $[57] = address;
    $[58] = assignPrimary;
    $[59] = assigningPrimary;
    $[60] = canEdit;
    $[61] = isPrimary;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  const t30 = `${isTouchScreen ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-ml-2 tw-p-1.5 tw-bg-transparent tw-cursor-pointer tw-text-xs tw-font-semibold tw-text-iron-400 hover:tw-text-iron-200 tw-border-0 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out`;
  const t31 = `copy-tooltip-${address.wallet}`;
  const t32 = isTouchScreen ? undefined : "Copy";
  let t33;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <CopyIcon />;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== handleCopy || $[65] !== t30 || $[66] !== t31 || $[67] !== t32) {
    t34 = <button aria-label="Copy address" className={t30} onClick={handleCopy} data-tooltip-id={t31} data-tooltip-content={t32}>{t33}</button>;
    $[64] = handleCopy;
    $[65] = t30;
    $[66] = t31;
    $[67] = t32;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== address.wallet || $[70] !== isTouchScreen) {
    t35 = !isTouchScreen && <Tooltip id={`copy-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[69] = address.wallet;
    $[70] = isTouchScreen;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] !== t29 || $[73] !== t34 || $[74] !== t35) {
    t36 = <div className="tw-inline-flex tw-items-center">{t28}{t29}{t34}{t35}</div>;
    $[72] = t29;
    $[73] = t34;
    $[74] = t35;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t27 || $[77] !== t36) {
    t37 = <div className="tw-space-x-3 tw-inline-flex tw-items-center">{t27}{t36}</div>;
    $[76] = t27;
    $[77] = t36;
    $[78] = t37;
  } else {
    t37 = $[78];
  }
  let t38;
  if ($[79] !== t17 || $[80] !== t18 || $[81] !== t22 || $[82] !== t23 || $[83] !== t37) {
    t38 = <div className="tw-h-5 tw-group tw-flex tw-items-center tw-group tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-200 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out tw-space-x-3">{t17}{t18}{t22}{t23}{t37}</div>;
    $[79] = t17;
    $[80] = t18;
    $[81] = t22;
    $[82] = t23;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== statusMessage) {
    t39 = statusMessage && <div className="pt-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-200 d-flex flex-column gap-1">{statusMessage}</div>;
    $[85] = statusMessage;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== t38 || $[88] !== t39) {
    t40 = <li>{t38}{t39}</li>;
    $[87] = t38;
    $[88] = t39;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  return t40;
}